export const FOOD_CHARTS_INJECTION_KEY = Symbol('foodChartsInjectionKey');
